import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import Filter from 'components/Filter/Filter';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import PaginatedItemsProvider from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import FramesPageTableHeader from 'features/Frames/components/Frames/FramesPageTableHeader';
import FramesTable from 'features/Frames/components/Frames/FramesTable';
import { State } from 'features/Frames/types';
import { stateReader } from 'features/Status/utils/statusWriter';
import { addFiltersToUrl } from 'utils/addFiltersToUrl';
import { FRAMES_TABLE_PAGE_SIZE } from 'utils/defaults';
import { FRAMES_API_URL } from 'utils/environmentVariables';

const OVERRIDE_PARAM = 'status';
const FramesPage = () => {
  const { filters } = useFilters();
  const { searchParams } = useSearchParamsProvider();

  const tablesWithoutFiltering = () =>
    Object.entries(State).map(([, value]: [string, State]) => {
      const url = addFiltersToUrl(FRAMES_API_URL, searchParams, OVERRIDE_PARAM, value);
      return (
        <div key={value}>
          <PaginatedItemsProvider pageableUrl={url} pageSize={FRAMES_TABLE_PAGE_SIZE}>
            <FramesTable idSuffix={value} header={<FramesPageTableHeader state={value} />} />
          </PaginatedItemsProvider>
        </div>
      );
    });

  const tablesWithFiltering = () =>
    filters.status.map((status) => {
      const state = stateReader(status);
      const url = addFiltersToUrl(FRAMES_API_URL, searchParams, OVERRIDE_PARAM, state);
      return (
        <div key={status}>
          <PaginatedItemsProvider pageableUrl={url} pageSize={FRAMES_TABLE_PAGE_SIZE}>
            <FramesTable idSuffix={state} header={<FramesPageTableHeader state={state} />} />
          </PaginatedItemsProvider>
        </div>
      );
    });

  return (
    <main>
      <Filter></Filter>
      <Typography variant="h2" fontWeight="bold">
        All Frames
      </Typography>
      {filters.status && (
        <>{!filters.status.length ? tablesWithoutFiltering() : tablesWithFiltering()}</>
      )}
    </main>
  );
};

export default FramesPage;
